import { useSearchParams } from 'react-router-dom';
import { SignIn } from '@clerk/clerk-react';
import {
  AuthPageLayout,
  LeftBrandContainer,
  LeftBrandContent,
  RightContentArea
} from '../../components/auth/SharedAuthComponents';
import { withMarketingParams } from '../../services/googleAds';

/** Only allow same-app relative paths — an absolute or protocol-relative URL
 *  ("https://evil.com", "//evil.com") would be an open redirect after sign-in.
 *  Also reject "/\evil.com": browsers normalize backslashes to forward slashes
 *  during URL resolution, turning it protocol-relative. */
function sanitizeRedirectUrl(raw: string | null): string | undefined {
  if (raw && /^\/(?![/\\])/.test(raw)) return raw;
  return undefined;
}

export default function Login() {
  const [searchParams] = useSearchParams();
  const redirectUrl = sanitizeRedirectUrl(searchParams.get('redirect_url'));

  return (
    <AuthPageLayout>
      <LeftBrandContainer>
        <LeftBrandContent
          title="CPE Compliance Without the Guesswork"
        />
      </LeftBrandContainer>

      <RightContentArea>
        <SignIn
          fallbackRedirectUrl={withMarketingParams('/')}
          forceRedirectUrl={redirectUrl ? withMarketingParams(redirectUrl) : undefined}
          signUpUrl="/auth/individual-signup"
        />
      </RightContentArea>
    </AuthPageLayout>
  );
}
